import EditSolidSVG from "@design-system/ui-icons/vanilla/EditSolid"
import { createIcon } from "../createIcon"

export const EditSolidIcon = createIcon(EditSolidSVG)
